import { Flex, FormItem } from "@/base/components/index";
import { FieldSearch } from "@/components/field-search/components/field-search";
import { SupervisorGuard } from "@/components/supervisor-guard/components/supervisor-guard";
import { usePageTableStyles } from "./data-table.styles";
import { useBreakpoint } from "@/base/utils/index";
import { useContextDataTable } from "../context/index";

export const DataTableActions = () => {
  const screens = useBreakpoint();
  const { styles } = usePageTableStyles();
  const { localization, actions, searched } = useContextDataTable();

  if (!searched && !actions) {
    return null;
  }

  return (
    <Flex gap={12} vertical={!screens.md} justify="space-between">
      {searched && (
        <FormItem noStyle name="search">
          <FieldSearch
            className={styles.search}
            placeholder={localization.getText(
              "composite.data.table.search.placeholder",
            )}
          />
        </FormItem>
      )}

      {actions && (
        <SupervisorGuard>
          <Flex
            gap={12}
            vertical={!screens.md}
            justify="flex-end"
            className={styles.actions}
          >
            {actions}
          </Flex>
        </SupervisorGuard>
      )}
    </Flex>
  );
};
